<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag v-decorator="[ 'status', validatorRules.status]" placeholder="请选择状态" ref="inspectionTaskStatusRef"  :trigger-change="true"  />
        </a-form-item>
        <a-form-item label="任务名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="[ 'taskName', validatorRules.taskName]" placeholder=""></a-input>
        </a-form-item>
        <a-form-item label="基地" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="[ 'baseId_dictText', validatorRules.baseId_dictText]" placeholder=""></a-input>
        </a-form-item>
        <a-form-item label="部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="[ 'departId_dictText', validatorRules.departId_dictText]" placeholder=""></a-input>
        </a-form-item>
        <a-form-item label="区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="[ 'workshopId_dictText', validatorRules.workshopId_dictText]" placeholder=""></a-input>
        </a-form-item>
        <a-form-item label="区域责任人姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="[ 'workshopUserName', validatorRules.workshopUserName]" placeholder=""></a-input>
        </a-form-item>
        <a-form-item label="巡查人名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="[ 'userName', validatorRules.userName]" placeholder=""></a-input>
        </a-form-item>
        <a-form-item label="进厂时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date disabled placeholder="" v-decorator="[ 'goInTime', validatorRules.goInTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="出厂时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date disabled placeholder="" v-decorator="[ 'goOutTime', validatorRules.goOutTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="是否提交改善方案" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="[ 'submitPlan', validatorRules.submitPlan]" placeholder=""></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JDate from '@/components/jeecg/JDate'  
  import {ajaxGetDictItems} from '@/api/api'

  export default {
    name: "BusInspectionTaskModal",
    components: { 
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          taskName: {rules: [
          ]},
          taskNo: {rules: [
            {required: true, message: '请输入任务编码!'},
          ]},
          inspectionWorkshop: {rules: [
          ]},
          inspectionDepart: {rules: [
          ]},
          inspectionBase: {rules: [
          ]},
          userNo: {rules: [
          ]},
          status: {rules: [
          ]},
          submitPlan: {rules: [
          ]},
          qrCodeNo: {rules: [
          ]},
          goInTime: {rules: [
          ]},
          goOutTime: {rules: [
          ]},
          userName: {rules: [
          ]},
          workshopUserNo: {rules: [
          ]},
          workshopUserName: {rules: [
          ]},
          submitPlanTime: {rules: [
          ]},
          expireStartTime: {rules: [
          ]},
          expireEndTime: {rules: [
          ]},
        },
        url: {
          add: "/general/busInspectionTask/add",
          edit: "/general/busInspectionTask/updateStatus",
        }
      }
    },
    created () {
    },
    methods: {
      initDictData() {
        //根据字典Code, 初始化字典数组
        ajaxGetDictItems("inspection_task_status", null).then((res) => {
          if (res.success) {
            let dictOptions = res.result.map((item)=>{
              if(item.value=="WaitExecute"||item.value=="LeaveBusiness"){
                item.disabled=false
                return item
              }else{
                item.disabled=true
                return item
              }
            })
            if(this.$refs.inspectionTaskStatusRef){
              this.$refs.inspectionTaskStatusRef.setCurrentDictOptions(dictOptions)
            }
          }
        })
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'taskName','inspectionWorkshop','inspectionDepart','inspectionBase','status','submitPlan','goInTime','goOutTime','userName','workshopUserName',"baseId_dictText","departId_dictText","workshopId_dictText"))
          this.initDictData()
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'taskName','taskNo','inspectionWorkshop','inspectionDepart','inspectionBase','status','submitPlan','goInTime','goOutTime','userName','workshopUserName'))
      },
    }
  }
</script>